import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add Dms
export const addDms = async (formData) => {
  const token = localStorage.getItem("authToken");

  try {
    // const data = new FormData();

    // const itemsPayload = formData.items.map(item => ({
    //   document: item.document,
    //   verified: item.verified,
    //   flag: item.flagStatus, // Map to backend's expected field name
    //   remark: item.remark,
    //   attachmentType: "dms",
    //   site: item.siteName, // Map to backend's expected field name
    //   fileName: item.fileName || "", // Ensure fileName is included
    //   fileUrl: item.fileUrl || "" // Ensure fileUrl is included
    // }));

    // data.append("items", JSON.stringify(itemsPayload));

    // Append files with proper field names
    //     formData.items.forEach((item) => {
    //       if (item.files instanceof File) {
    //         data.append("files", item.files); // Keep same name for backend
    //       }
    //     });

    //     // Append dealId if available
    //     data.append("dealId", formData.dealId || "");

    //  console.log("Sending payload:", data)

    const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/create-net-metering`, formData, {
      headers: {
        "auth-token": token,
      },
    });

    console.log("Adding net metering", response);
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const updateNetMatriningApi = async (formData) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-net-metering/${formData?.ROWID}`, formData, {
      headers: {
        "auth-token": token,
      },
    });

    console.log("Adding net metering", response);
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const updateNetDoc = async (data) => {
  console.log({ data });
  const ROWID = data.ROWID;
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-net-metering-document/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteNetDms = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/dms/app/v1/delete-net-metering/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("delete document --", response);
    return response;
  } catch (error) {
    throw error;
  }
};

export const addKyc = async (formData) => {
  const token = localStorage.getItem("authToken");

  try {
    const data = new FormData();

    // Append basic fields
    data.append("kycName", formData.kycName || "");
    data.append("kycDepartment", formData.kycDepartment || null);
    data.append("phone", formData.phone || "");
    data.append("street", formData.street || "");
    data.append("city", formData.city || "");
    data.append("state", formData.state || "");
    data.append("zipCode", formData.pinCode || "");
    data.append("country", formData.country || "");
    data.append("dealId", formData.dealId || null);
    // data.append("leadId", formData.leadId || null);
    data.append("status", formData.status || "pending");
    data.append("loadEntered", formData.loadEntered || "");

    // Only send the metadata in the items array
    const itemMeta = formData.items.map((item) => ({
      document: item.document,
      verified: item.verified,
      flag: item.flag,
      remark: item.remark,
      loadEntered: item.loadEntered,
    }));

    data.append("items", JSON.stringify(itemMeta));

    // Send the files separately (the order will be used to match them in backend)
    formData.items.forEach((item) => {
      if (item.files instanceof File) {
        data.append("files", item.files); // Keep same name for backend
      }
    });

    const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/create-kyc`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "multipart/form-data",
      },
    });

    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const updateKyc = async (kycId, formData) => {
  const token = localStorage.getItem("authToken");

  try {
    const data = new FormData();

    // // Append basic fields (same as addKyc for consistency)
    // data.append("kycName", formData.kycName || "");
    // data.append("phone", formData.phone || "");
    // data.append("street", formData.street || "");
    // data.append("city", formData.city || "");
    // data.append("state", formData.state || "");
    // data.append("zipCode", formData.pinCode || "");
    // data.append("country", formData.country || "");
    // data.append("dealId", formData.dealId || "");
    // data.append("status", formData.status || "");
    // data.append("loadEntered", formData.loadEntered || "");

    // // Prepare items metadata (include ROWID for updates)
    // const itemMeta = formData.items.map((item) => ({
    //   ROWID: item.ROWID || null, // Include ROWID for existing items
    //   document: item.document,
    //   verified: item.verified,
    //   flag: item.flag,
    //   remark: item.remark,
    //   loadEntered: item.loadEntered,
    // }));

    // data.append("items", JSON    // verified: item.verified || false,
    // flag: item.flag || false,
    // remark: item.remark || "",
    // loadEntered: item.loadEntered || "",.stringify(itemMeta));

    // Append basic fields
    data.append("kycName", formData.kycName || "");
    data.append("kycDepartment", formData.kycDepartment || null);
    data.append("phone", formData.phone || "");
    data.append("street", formData.street || "");
    data.append("city", formData.city || "");
    data.append("state", formData.state || "");
    data.append("zipCode", formData.pinCode || "");
    data.append("country", formData.country || "");
    data.append("dealId", formData.dealId || null);
    // data.append("leadId", formData.leadId || null);
    data.append("status", formData.status || "");
    data.append("loadEntered", formData.loadEntered || "");

    // Prepare items metadata
    const itemMeta = formData.items.map((item) => {
      const meta = {
        document: item.document || "",
        // verified: item.verified || false,
        // flag: item.flag || false,
        // remark: item.remark || "",
        // loadEntered: item.loadEntered || "",
      };
      if (item.ROWID && item.ROWID.trim() !== "") {
        meta.ROWID = item.ROWID.trim();
      }
      return meta;
    });

    data.append("items", JSON.stringify(itemMeta));

    // Append files only for items without ROWID
    formData.items.forEach((item) => {
      if (item.files instanceof File) {
        data.append("files", item.files);
      } else if (item.files?.file instanceof File) {
        data.append("files", item.files.file);
      }
    });

    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-kyc/${kycId}`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Update KYC Error:", error);
    throw error;
  }
};
export const deleteKyc = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/dms/app/v1/delete-kyc/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("responsedelete", response);
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateDoc = async (data) => {
  console.log({ data });
  const ROWID = data.ROWID;
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-kyc-document/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateNationalPortalDoc = async (data) => {
  console.log({ data });
  const ROWID = data.ROWID;
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-NationalPortal-document/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteKycDoc = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/dms/app/v1/delete-kyc-document/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("delete document --", response);
    return response;
  } catch (error) {
    throw error;
  }
};

// delete lead  API
export const deleteDms = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/dms/app/v1/delete-dms/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    console.log("deleteresponse", response);
    return response;
  } catch (error) {
    throw error;
  }
};

// total count
export const countLead = async (formData) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-count-leads`, formData, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
// Get dms By ID
export const getLeadbyId = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-related-list/${ROWID.id}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching Lead by id - ", error);
    throw error;
  }
};
export const dmsfileUpload = async (data) => {
  const formDataToSend = new FormData();

  const file = data.file;
  const moduleName = data.type;
  const bucketName = data.siteId;

  formDataToSend.append("type", data.type);
  formDataToSend.append("siteId", data.siteId);
  formDataToSend.append("files", data.files);
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/upload-type-files`, formDataToSend, {
      headers: {
        "auth-token": token,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const addSubsidy = async (formData) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/dms/app/v1/create-subsidy`, formData, {
      headers: {
        "auth-token": token,
      },
    });

    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};
export const UpdateSubsidy = async (formData) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-subsidy/${formData?.ROWID}`, formData, {
      headers: {
        "auth-token": token,
      },
    });

    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const addNastionalPortel = async (formData) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(
      `${baseUrl}cleaningappfunctions/dms/app/v1/create-nationalPortal`,
      formData, // already built in handleSubmit
      {
        headers: {
          "auth-token": token,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

// update
export const updateNastionalPortel = async (ROWID, formData) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.put(
      `${baseUrl}cleaningappfunctions/dms/app/v1/update-nationalPortal/${ROWID}`,
      formData, // already built in handleSubmit
      {
        headers: {
          "auth-token": token,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const deleteNastionalPortel = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/dms/app/v1/delete-nationalPortal/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteNastionalPortelDocument = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/dms/app/v1/delete-NationalPortal-document/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const addNastionaPortel = async (formData) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(
      `${baseUrl}cleaningappfunctions/dms/app/v1/create-nationalPortal`,
      formData, // already built in handleSubmit
      {
        headers: {
          "auth-token": token,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const updateNPDoc = async (data) => {
  console.log({ data });
  const ROWID = data.ROWID;
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-NationalPortal-document/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
//subsidy

export const deleteSubsidy = async (ROWID) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.delete(`${baseUrl}cleaningappfunctions/dms/app/v1/delete-subsidy/${ROWID}`, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSubDoc = async (data) => {
  console.log({ data });
  const ROWID = data.ROWID;
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/dms/app/v1/update-subsidy-document/${ROWID}`, data, {
      headers: {
        "auth-token": token,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};


export const getNationalPortalByID = async (ROWID) => {
  const token = localStorage.getItem("authToken")
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/dms/app/v1/get-nationalPortal-by-id/${ROWID}`, {
      headers: {
        "auth-token": token,
      }
    })
    // console.log('<<<<<<<<<<<<<<<<<<<<<companires>>>>>>>>>>>>>>>>>',response)
    return response
  } catch (error) {
    throw error
  }
}